export const commandNames = {
  closeWizardCommand: 'CloseWizardCommand',
  createClaimCommand: 'CreateClaimCommand',
  createEnquiryCommand: 'CreateEnquiryCommand',
  openDuplicateJobCommand: 'OpenDuplicateJobCommand',
  createHelplineClaimCommand: 'CreateHelplineClaimCommand',
}
